import Index from "views/Index.js";
import Profile from "views/Profile.js";
import Login from "views/Login.js";
// import Clientms from "views/cms";
import Tutors from "views/Tutors";
import Tutorss from "views/Notification/index"
import Banner from "views/banner/Banner";
import AddTutors from "views/Tutors/AddTutors";
import User from "views/User";
import AddUser from "views/User/AddUser";
import AddStudent from "views/Student.js/AddStudent";
import Students from "views/Student.js";
import ShortlistUser from "views/ShortlistUser";
import Grades from "views/Grades";
import AddGrades from "views/Grades/AddGrades";
import Subject from "views/Subjects";
import AddSubject from "views/Subjects/AddSubject";
import Enquiry from "views/Enquiry";
import Classes from "views/Classes";
import Questions from "views/Questions";
import QuestionPapers from "views/QuestionPapers";
import Notice from "views/Notice/index";
import Notification from "views/Notification";
import Faqs from "views/Faqs";
import ContactUs from "views/ContactUs";
import Form from "views/Form";
import AddContactUs from "views/ContactUs/AddContactUs";
import AddQuestionPapers from "views/QuestionPapers/AddQuestion-P";
import AddQuestions from "views/Questions/AddQuestions";
import AddFaqs from "views/Faqs/AddFaqs";
import EditFaqs from "views/Faqs/EditFaqs";
import EditContactUs from "views/ContactUs/EditContactUs";
import Feedback from "views/Feedback";
import Compliance from "views/compliance";
import Guide from "views/Guide";
import AddGuide from "views/Guide/AddGuide";
import EditGuide from "views/Guide/EditDuide";
import Academic from "views/academic";
import TutorsProfile from "views/Tutors/TutorsProfile";
import EditTutors from "views/Tutors/EditTutors";
import EditUser from "views/User/EditUser";
import EditGrades from "views/Grades/EditGrades";
import EditSubject from "views/Subjects/EditSubject";
import EditClasses from "views/Classes/EditClasses";
import AddClasses from "views/Classes/AddClasses";
import EditQuestion from "views/Questions/EditQuestions";
import EditQuestionPapers from "views/QuestionPapers/EditQuestion-P";
import Addacademic from "views/academic/Addacademic";
import Editacademic from "views/academic/Editacademic";
import ParentsProfile from "views/Student.js/ParentsProfile";
import VideoQuestionsManagement from "views/VideoQuestionsManagement";
import AddVideoQuestionManagment from "views/VideoQuestionsManagement/AddVideoQuestionManagment";
import EditVideoQuestionManagment from "views/VideoQuestionsManagement/EditVideoQuestionManagment";
import City from "views/City";
import AddCity from "views/City/AddCity";
import EditCity from "views/City/EditCity";
import SubAcademiccategory from "views/academic/Board";
import ClassAca from "views/academic/Class";
import SubjectAca from "views/academic/Subject";
import Attendance from "views/Classes/attendance/Attendance";
import ClassStudentlist from "views/Classes/ClassStudentlist";
import State from "views/state/index";
import AddState from "views/state/AddState";
import EditState from "views/state/EditState";
import Level from "views/Tutors/TutorsProfile/Level";
import MainLevel from "views/Level/Index";
import NewEnquiries from "views/Enquiry/SubEnquiryPage/NewEnquiries";
import QualifiedEnquiries from "views/Enquiry/SubEnquiryPage/QualifiedEnquiries";
import PendingEnquiries from "views/Enquiry/SubEnquiryPage/PendingEnquiries";
import DisqualifiedEnquiries from "views/Enquiry/SubEnquiryPage/DisqualifiedEnquiries";
import ViewPage from "views/Enquiry/SubEnquiryPage/viewPage";
import QualifiedEnquiriesViewPage from "views/Enquiry/SubEnquiryPage/QualifiedEnquiriesViewPage";
import LinkTutorsEnquiries from "views/Enquiry/SubEnquiryPage/LinkTutorsEnquiries";
import EHC from "views/EHC";
import ViewEHC from "views/EHC/view/ViewEHC";
import AttendanceProfile from "views/Classes/attendance/AttendanceProfile";
import AddProfile from "views/Tutors/Profile/AddProfile";
import Product from "views/Product";
import AddProduct from "views/Product/AddProduct";
import CreditMapping from "views/Classes/CreditMapping";
import ViewCreditMapping from "views/Classes/creditmapping/ViewCreditMapping";
import TutorsReplacementAll from "views/Classes/creditmapping/TutorsReplacementAll";
import InterViewDetails from "views/Tutors/TutorsProfile/InterViewDetails";
import EditEnquriStudentDetails from "views/Enquiry/SubEnquiryPage/EditEnquriStudentDetails";
import SupportTicket from "views/SupportTicket";
import Addticket from "views/SupportTicket/Addticket";
import ViewTicket from "views/SupportTicket/ViewTicket";
import StudetLeadBoard from "views/LeadBoard/studentLeadeBoard";
import TutorsLeadBoard from "views/LeadBoard/tutorLeadBoard";
import AddLeadeBoard from "views/LeadBoard/AddLeadeBoard";
import Referl from "views/Referl";
import Report from "views/Report/incomebreakdown/index";
import TutorPayRoll from "views/tutorPayroll";
import ViewHistory from "views/tutorPayroll/ViewHistory";
import View from "views/tutorPayroll/View";
import EditProduct from "views/Product/EditProduct";
import FinanceManagement from "views/FinanceManagement";
import ViewInvoice from "views/FinanceManagement/ViewInvoice";
import DraftTutorsSalary from "views/FinanceManagement/DraftTutorsSalary";
import DraftTutorsSalaryView from "views/FinanceManagement/DraftTutorsSalaryView";
import DraftPaymentOrader from "views/FinanceManagement/DraftPaymentOrader";
import ClassvView from "views/Classes/ClassSummary/ClassvView";
import { FaSketch } from "react-icons/fa";
import AddNotifaction from "views/Tutors/AddNoticufaction";
import Blog from "views/blog/blog";
import Contactlist from "views/Contactlist/Contactlist";
import Vedio from "views/vedio/Vedio";
import Production from "views/production/Production";
import Inquiry from "views/inquiry/Inquiry";
import Studentleaderboard from "views/studentleaderboard/Studentleaderboard"
import Tutorleaderboard from "views/tutorleaderboard/Tutorleaderboard"
import Echlistdetail from "views/EHC/Echlistdetail";
import Testuser from "views/testuser"
import AllTransaction from "views/FinanceManagement/Alltransaction.js"
import Clientbalance from "views/clientbalance/Clientbalance";
import Revenue from "views/Report/revenue";
import Incomeovertime from "views/Report/incomeovertime";
import Payments from "views/Tutors/TutorsProfile/Payments";
import LevelLinking from "views/classlevellink";
import AddClassesbyid from "views/Classes/AddClassesbyid";
import Callbackrequest from "views/callbackrequest";



var routes = [


  {
    path: "/index",
    name: "Dashboard",
    icon: "fa fa-home text-primary",
    component: <Index />,
    layout: "/admin",
    IsVisible: true,
  },
  // People
  {
    path: "/tutors",
    name: "People",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Tutors />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/tutors",
        name: "Tutors",
        icon: "fa fa-chalkboard-user text-primary",
        component: <Tutors />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/student",
        name: "Parents",
        icon: "fa-solid fa-child-dress text-primary",
        component: <Students />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/user",
        name: "Sub-Admin",
        icon: "fas fa-user text-primary",
        component: <User/>,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },

  // Activities
  {
    path: "/newenquiries",
    name: "Activities",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <NewEnquiries />,
    layout: "/admin",
    IsVisible: true,
    children: [
      //  {
      //   name: " Enquiry Mgt",
      //   path: "/newenquiries",
      //   layout: "/admin",
      //  icon: "fa-solid fa-cart-plus text-primary",
      //  component: <NewEnquiries />,
      //  IsVisible: true,
      // },
      {
        name: "Class mgt",
        path: "/classes",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Classes />,
        IsVisible: true,
      },
      {
        name: "Support ticket",
        path: "/supportticket",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <SupportTicket />,
        IsVisible: true,
      },
      {
        path: "/ehc",
        name: "EHC",
        icon: "ni ni-single-02 text-primary",
        component: <EHC />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/referl",
        name: "Referl",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <Referl />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/shortlistUser",
        name: "Shortlist Tutors",
        icon: "fa fa-chalkboard-user text-primary",
        component: <ShortlistUser />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        name: "All Attendance",
        path: "/attendance",
        layout: "/admin",
        icon: "fa-solid fa-clock-rotate-left text-primary",
        component: <Attendance />,
        IsVisible: true,
      },
      {
        name: "Credit Mapping",
        path: "/creditmapping",
        layout: "/admin",
        icon: "fa-solid fa-clock-rotate-left text-primary",
        component: <CreditMapping />,
        IsVisible: true,
      },
      {
        name: " Tutor's Payroll",
        path: "/tutorpayroll",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <TutorPayRoll />,
        IsVisible: true,
      },
    ],
  },

  {
    path: "/shortlistUser/:id/:mid",
    name: "Tutor Lined-up",
    icon: "fa fa-chalkboard-user text-primary",
    component: <ShortlistUser />,
    layout: "/admin",
    IsVisible: false,
  },
  // Communication 
  {
    path: "/notification",
    name: "Communication ",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Tutorss />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/notification",
        name: "Notification / Notice",
        icon: "fa fa-chalkboard-user text-primary",
        component: <Tutorss />,
        layout: "/admin",
        IsVisible: true,
      },
      //{
      //   path: "/",
      //  name: "Announcement",
      //  icon: "fa-solid fa-child-dress text-primary",
      //  component: <Students />,
      //  layout: "/admin",
      //  IsVisible: true,
      // },
      // {
      //  path: "/",
      //  name: "Notice",
      //  icon: "fas fa-user text-primary",
      // component: <User />,
      //  layout: "/admin",
      //  IsVisible: true,
      //},

    ],
  },
  {
    path: "/AddNotification",
    component: <AddNotifaction />,
    layout: "/admin",
    IsVisible: false,
  },
  // FInance Mgt

  {
    path: "/raiseinvoice",
    name: "Finance Management",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <FinanceManagement />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        name: "Raise Invoice",
        path: "/raiseinvoice",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <FinanceManagement />,
        IsVisible: true,
      },

      {
        name: "Draft Tutor Salary",
        path: "/draftTutorsSalary",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <DraftTutorsSalary />,
        IsVisible: true,
      },


      {
        name: "All Transaction",
        path: "/alltransactiones",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <AllTransaction />,
        IsVisible: true,
      },

      {
        name: "Client Balance",
        path: "/clientbalance",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Clientbalance />,
        IsVisible: true,
      },



    ],
  },
  // Useful Corners
  {
    path: "/newenquiries",
    name: "Useful Corners",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <NewEnquiries />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/videoquestionsmanagement",
        name: "Questions Mgmt.",
        icon: "fa-solid fa-file-circle-question text-primary",
        component: <VideoQuestionsManagement />,
        layout: "/admin",
        IsVisible: false,
      },
      {
        path: "/callbackrequest",
        name: "Callback Request",
        icon: "fa-solid fa-file-circle-question text-primary",
        component: <Callbackrequest />,
        layout: "/admin",
        IsVisible: false,
      },
      {
        path: "/fAQs",
        name: "FAQs",
        icon: "fa-solid fa-file-circle-question text-primary",
        component: <Faqs />,
        layout: "/admin",
        IsVisible: false,
      },
      {
        path: "/contactlist",
        name: "Contact List",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <Contactlist />,
        layout: "/admin",
        IsVisible: true,
      },



      {
        path: "/feedback",
        name: "Feedback",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <Feedback />,
        layout: "/admin",
        IsVisible: false,
      },

      {
        path: "/state",
        name: "State",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <State />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/city",
        name: "City",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <City />,
        layout: "/admin",
        IsVisible: true,
      },

      //   {
      //    path: "/level",
      //  name: "Level",
      //     icon: "ni ni-single-02 text-primary",
      //    component: <MainLevel />,
      //   layout: "/admin",
      //   IsVisible: true,
      //  },

      {
        path: "/levellinking",
        name: "Level Linking",
        icon: "ni ni-single-02 text-primary",
        component: <LevelLinking />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/academic",
        name: "Academic",
        icon: "fa fa-chalkboard-user text-primary",
        component: <Academic />,
        layout: "/admin",
        IsVisible: true,

      },
      {
        name: "Product",
        path: "/product",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Product />,
        IsVisible: true,
      },
      {
        name: "All Videos",
        path: "/vedio",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Vedio />,
        IsVisible: true,
      },
      {
        path: "/referl",
        name: "Referl",
        icon: "fa-solid fa-id-card-clip text-primary",
        component: <Referl />,
        layout: "/admin",
        IsVisible: true,
      },

    ],
  },

  // Others

  //{
  //  name: "Video",
  //  path: "/vedio",
  //  layout: "/admin",
  //  icon: "fa-solid fa-person-circle-question text-primary",
  // component: <Vedio/>,
  // IsVisible: true,

  //},
  {
    name: "Test user",
    path: "/testuser",
    layout: "/admin",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Testuser />,
    IsVisible: true,

  },
  ////{
  // name: "Contact List",
  // path: "/Contactlist",
  // layout: "/admin",
  ////icon: "fa-solid fa-person-circle-question text-primary",
  // component: <Contactlist/>,
  // IsVisible: true,

  // },
  {
    name: "Banner",
    path: "/Banner",
    layout: "/admin",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Banner />,
    IsVisible: true,
  },
  {
    name: "Blogs",
    path: "/Blog",
    layout: "/admin",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Blog />,
    IsVisible: true,
  },
  {
    name: "Student Leader Board",
    path: "/Studentleaderboard",
    layout: "/admin",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Studentleaderboard />,
    IsVisible: true,
  },
  {
    name: "Tutor Leader Board",
    path: "/Tutorleaderboard",
    layout: "/admin",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Tutorleaderboard />,
    IsVisible: true,
  },

  //inqury
  //{
  //  name: "Inquiry",
  // path: "/inquiry",
  // layout: "/admin",
  //icon: "fa-solid fa-person-circle-question text-primary",
  //component: <Inquiry/>,
  //IsVisible: true,

  //},

  // Dashboard

  {
    path: "/report/incomebreakdown",
    name: "Report",
    icon: "fa-solid fa-cart-plus text-primary",
    component: < Report />,
    layout: "/admin",
    IsVisible: true,
    children: [
      // Report
      {
        name: "Income Breakdown",
        path: "/report/incomebreakdown",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: < Report />,
        IsVisible: true,
      },
      {
        name: "Revenue Snapshot",
        path: "/report/revenue",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: < Revenue />,
        IsVisible: true,
      },
      {
        name: "Income OverTime",
        path: "/report/incomeovertime",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: < Incomeovertime />,
        IsVisible: true,
      },
    ]
  },

  {
    path: "/tutors",
    name: "Tutors",
    // icon: "fa fa-chalkboard-user text-primary",
    component: <Tutors />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/tutors/addtutors/",
    component: <AddTutors />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/tutors/edittutors/",
    component: <EditTutors />,
    layout: "/admin",
    IsVisible: false,
  },
  {

    path: "/tutors/tutorsprofile/:id/:mid",
    // path: "/tutors/tutorsprofile/:id",
    component: <TutorsProfile />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/classes/classsummary/:id/:mid",
    component: <ClassvView />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/addprofile/:mid/:id/:md",
    component: <AddProfile />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/viewenquiry/EditEnquriParentDetails/:mid/:id/:sid",
    component: <EditEnquriStudentDetails />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/tutors/edittutors/",
    component: <EditTutors />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/student",
    // name: "Parents",
    // icon: "fa-solid fa-child-dress text-primary",
    component: <Students />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/student/addstudent/",
    component: <AddStudent />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/student/parentsProfile/:id/:pid",
    component: <ParentsProfile />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/student/editstudent/",
    component: <AddStudent />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/creditmapping/creditmapping-view/tutors-replacement",
    component: <TutorsReplacementAll />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/tutors/tutorsprofile/interViewDetails",
    component: <InterViewDetails />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    path: "/board/:id",
    icon: "fa fa-chalkboard-user text-primary",
    component: <SubAcademiccategory />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/class/:id",
    icon: "fa fa-chalkboard-user text-primary",
    component: <ClassAca />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/subjectaca/:id",
    icon: "fa fa-chalkboard-user text-primary",
    component: <SubjectAca />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/addacademicsub/:id",
    component: <Addacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/board/:id",
    component: <Addacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/class/:id",
    component: <Addacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/subject/:id/:name",
    component: <Addacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/addacademic/",
    component: <Addacademic />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/academic/editacademic/:id",
    component: <Editacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/editboard/:id/:perentId",
    component: <Editacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/editclass/:id/:perentId",
    component: <Editacademic />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/academic/editsubject/:id/:perentId/:name",
    component: <Editacademic />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/user",
    name: "Sub-Admin",
    icon: "fas fa-user text-primary",
    component: <User />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/academic",
    name: "Academic",
    icon: "fa fa-chalkboard-user text-primary",
    component: <Academic />,
    layout: "/admin",
    IsVisible: false,

  },
  {
    path: "/qualifiedenquiriesviewpage/:id",
    name: "Sub-Admin",
    icon: "fas fa-user text-primary",
    component: <QualifiedEnquiriesViewPage />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    //path: "/linktutorsenquiries/:mid/:id",
    path: "/linktutorsenquiries/:id/:mid",
    name: "Sub-Admin",
    icon: "fas fa-user text-primary",
    component: <LinkTutorsEnquiries />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/user/adduser/",
    component: <AddUser />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/user/edituser/:id/:mid",
    component: <EditUser />,
    layout: "/admin",
    IsVisible: false,
  },



  {
    path: "/grades/addgrades/",
    component: <AddGrades />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/grades/editgrades/",
    component: <EditGrades />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    path: "/subject/addsubject/",
    component: <AddSubject />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/subject/editsubject/",
    component: <EditSubject />,
    layout: "/admin",
    IsVisible: false,
  },
  //Enruiry
  {
    path: "/newenquiries",
    name: "Enquiry",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <NewEnquiries />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        name: "New Enq",
        path: "/newenquiries",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <NewEnquiries />,
        IsVisible: true,
      },
      {
        name: "Qualified Enq",
        path: "/qualifiedenquiries",
        icon: "fa-solid fa-check text-primary",
        component: <QualifiedEnquiries />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        name: "Pending Enq",
        path: "/pendingenquiries",
        layout: "/admin",
        icon: "fa-solid fa-clock-rotate-left text-primary",
        component: <PendingEnquiries />,
        IsVisible: true,
      },
      {
        name: "Disqualified Enq",
        path: "/disqualifiedenquiries",
        icon: "fa-solid fa-user-xmark text-primary",
        component: <DisqualifiedEnquiries />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },

  {
    name: "Disqualified Enquiries",
    path: "/disqualifiedenquiries",
    icon: "fa fa-chalkboard-user text-primary",
    component: <DisqualifiedEnquiries />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    name: "Pending Enquiries",
    path: "/pendingenquiries",
    layout: "/admin",
    icon: "fa fa-chalkboard-user text-primary",
    component: <PendingEnquiries />,
    IsVisible: false,
  },
  {
    name: "New Enquiries",
    path: "/newenquiries",
    layout: "/admin",
    icon: "fa fa-chalkboard-user text-primary",
    component: <NewEnquiries />,
    IsVisible: false,
  },

  {
    name: "Qualified Enquiries",
    path: "/qualifiedenquiries",
    icon: "fa fa-chalkboard-user text-primary",
    component: <QualifiedEnquiries />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/viewenquiry/:id/:pid",
    // name: "/view",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <ViewPage />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/classes",
    name: "Classes",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Classes />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: "All Classes",
        path: "/classes",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Classes />,
        IsVisible: true,
      },
      {
        name: "Add Class",
        path: "/classes/addclasss/",
        icon: "fa-solid fa-plus text-primary",
        component: <AddClasses />,
        layout: "/admin",
        IsVisible: false,
      },
      {
        name: "All Attendance",
        path: "/attendance",
        layout: "/admin",
        icon: "fa-solid fa-clock-rotate-left text-primary",
        component: <Attendance />,
        IsVisible: true,
      },

      {
        name: "Credit Mapping",
        path: "/creditmapping",
        layout: "/admin",
        icon: "fa-solid fa-clock-rotate-left text-primary",
        component: <CreditMapping />,
        IsVisible: true,
      },
    ],
  },



  {
    path: "/supportticket",
    name: "Support Tickets",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <SupportTicket />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: "All Tickets",
        path: "/supportticket",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <ViewTicket />,
        IsVisible: true,
      },
      {
        name: "Create Ticket",
        path: "/supportticket/addticket/",
        icon: "fa-solid fa-plus text-primary",
        component: <Addticket />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },
  {
    path: "/supportticket/addticket/:id",
    icon: "fa-solid fa-plus text-primary",
    component: <Addticket />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/ehc",
    name: "EHC",
    icon: "ni ni-single-02 text-primary",
    component: <EHC />,
    layout: "/admin",
    IsVisible: false,
  },




  {
    path: "/shortlistUser",
    name: "Shortlist Tutors",
    icon: "fa fa-chalkboard-user text-primary",
    component: <ShortlistUser />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/creditmapping",
    component: <CreditMapping />,
    layout: "/admin",
    icon: "fa fa-chalkboard-user text-primary",
    IsVisible: false,
    name: "Credit Mapping ",

  },

  {
    path: "/tutorpayroll",
    name: "Payrollessss",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <TutorPayRoll />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: " Tutor's Payroll list",
        path: "/tutorpayrolless",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <TutorPayRoll />,
        IsVisible: true,
      },
      {
        name: " Tutor's Payroll",
        path: "/tutorpayroll",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <StudetLeadBoard />,
        IsVisible: true,
      },

      {
        name: "Payment History",
        path: "/tutorpayroll/viewhistory",
        icon: "fa-solid fa-check text-primary",
        component: <ViewHistory />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },


  {
    path: "/studentleadboard",
    name: "Leadar Board",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <StudetLeadBoard />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: "Student",
        path: "/studentleadboard",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <StudetLeadBoard />,
        IsVisible: true,
      },

      {
        name: "Tutor",
        path: "/tutorleadboard",
        icon: "fa-solid fa-check text-primary",
        component: <TutorsLeadBoard />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },

  {
    path: "/report",
    name: "Report",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Report />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: "Gross Margin",
        path: "/report",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <StudetLeadBoard />,
        IsVisible: true,
      },

      // {
      //   name: "Tutor",
      //   path: "/tutorleadboard",
      //   icon: "fa-solid fa-check text-primary",
      //   component: <TutorsLeadBoard />,
      //   layout: "/admin",
      //   IsVisible: true,
      // },
    ],
  },




  {
    path: "/raiseinvoices",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <FinanceManagement />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/draftTutorsSalary",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <DraftTutorsSalary />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/product",
    name: "Product",
    icon: "fa-solid fa-person-circle-question text-primary",
    component: <Product />,
    layout: "/admin",
    IsVisible: false,
    children: [
      {
        name: "Produnct",
        path: "/product",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-primary",
        component: <Product />,
        IsVisible: true,
      },
      {
        name: "Add Product",
        path: "/product/addproduct/",
        icon: "fa-solid fa-plus text-primary",
        component: <AddProduct />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },

  {
    path: "/viewinvoice/:mid",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <ViewInvoice />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/sraftTutorsSalaryView",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <DraftTutorsSalaryView />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/draftPaymentOrader/:id",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <DraftPaymentOrader />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/report",
    name: "Report",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <Report />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/tutorpayroll/viewhistory",
    component: <ViewHistory />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/tutorpayroll/view/:id/:mid",
    component: <View />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/studentleadboard",
    component: <StudetLeadBoard />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/Echdetaillist/:id/:mid",
    component: <Echlistdetail />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    path: "/tutorleadboard",
    component: <TutorsLeadBoard />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/supportticket",
    component: <SupportTicket />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/addLeadeBoard",
    component: <AddLeadeBoard />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/supportticket/addticket/",
    component: <Addticket />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/supportticket/viewticker/",
    component: <ViewTicket />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/attendance/",
    component: <Attendance />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/studentlist/",
    component: <ClassStudentlist />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/creditmapping",
    component: <CreditMapping />,
    layout: "/admin",
    IsVisible: false,
    name: "Credit Mapping ",

  },
  {
    path: "/attendance/attendance-profile/:id/:parentid/:mid/:target",
    // path: "/attendance/attendance-profile/:id/:parentid/:mid",
    icon: "ni ni-single-02 text-primary",
    component: <AttendanceProfile />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    //path: "/attendance/attendance-profile/:id/:parentid/:mid/:target",
    path: "/attendance/attendance-profile/:id/:parentid/:mid",
    icon: "ni ni-single-02 text-primary",
    component: <AttendanceProfile />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/creditmapping/creditmapping-view/:id/:mid",
    icon: "ni ni-single-02 text-primary",
    component: <ViewCreditMapping />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/classes/editclasss/:id",
    component: <EditClasses />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/classes/addclasss/:id/:mid/:gid",
    component: <AddClassesbyid />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/product/addproduct/",
    component: <AddProduct />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/product/editproduct/:id",
    component: <EditProduct />,
    layout: "/admin",
    IsVisible: false,
  },


  // {
  //   path: "/questions",
  //   name: "Questions",
  //   icon: "fa-solid fa-file-circle-question text-primary",
  //   component: <Questions />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  {
    path: "/questions/addquestions/",
    component: <AddQuestions />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/questions/editquestions/",
    component: <EditQuestion />,
    layout: "/admin",
    IsVisible: false,
  },

  // {
  //   path: "/questionpapers",
  //   name: "Q-Papers",
  //   icon: "fa-solid fa-file-circle-question text-primary",
  //   component: <QuestionPapers />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },
  {
    path: "/questionpapers/addquestionpapers/",
    component: <AddQuestionPapers />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/questionpapers/editquestionpapers/",
    component: <EditQuestionPapers />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/videoquestionsmanagement",
    name: "Questions Mgmt.",
    icon: "fa-solid fa-file-circle-question text-primary",
    component: <VideoQuestionsManagement />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/videoquestionsmanagement/addvideoquestionsmanagement/",
    component: <AddVideoQuestionManagment />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    path: "/videoquestionsmanagement/editvideoquestionsmanagement/:id",
    component: <EditVideoQuestionManagment />,
    layout: "/admin",
    IsVisible: false,
  },

  // {
  //   path: "/form",
  //   name: "Form",
  //   icon: "fa-solid fa-user text-primary",
  //   component: <Form />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  // {
  //  path: "/notification",
  // name: "Notification",
  // icon: "fa-solid fa-file-circle-question text-primary",
  //component: <Notification />,
  // layout: "/admin",
  // IsVisible: false,
  //},

  // {
  //   path: "/notice",
  //   name: "Notice",
  //   icon: "fa-solid fa-file-circle-question text-primary",
  //   component: <Notice />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  {
    path: "/fAQs",
    name: "FAQs",
    icon: "fa-solid fa-file-circle-question text-primary",
    component: <Faqs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/fAQs/addfAQs",
    component: <AddFaqs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/fAQs/editfAQs/:id",
    component: <EditFaqs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/contactUs",
    name: "Contact Us",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <ContactUs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/contactUs/addcontactUs",
    component: <AddContactUs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/contactUs/editcontactUs",
    component: <EditContactUs />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/feedback",
    name: "Feedback",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <Feedback />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/compliance",
    name: "Complaints",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <Compliance />,
    layout: "/admin",
    IsVisible: false,
  },

  // {
  //   path: "/guide",
  //   name: "Guide",
  //   icon: "fa-solid fa-id-card-clip text-primary",
  //   component: <Guide/>,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  {
    path: "/guide/addguide",
    component: <AddGuide />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/guide/editguide",
    component: <EditGuide />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/state",
    name: "State",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <State />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/city/addstate",
    component: <AddState />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/city/editstate/:id",
    component: <EditState />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/city",
    name: "City",
    icon: "fa-solid fa-id-card-clip text-primary",
    component: <City />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/city/addcity",
    component: <AddCity />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/city/editcity/:id",
    component: <EditCity />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/user-profile",
    name: "Profile",
    icon: "ni ni-single-02 text-primary",
    component: <Profile />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/level",
    name: "Level",
    icon: "ni ni-single-02 text-primary",
    component: <MainLevel />,
    layout: "/admin",
    IsVisible: false,
  },


  {
    path: "/ehc/viewehc/:id/:uid/:mid",
    component: <ViewEHC />,
    layout: "/admin",
    IsVisible: false,
  },




  // {
  //   path: "/cms",
  //   name: "CMS",
  //   // icon: "ni ni-tv-2 text-primary",
  //   icon:"fa-solid fa-bars-progress text-black",
  //   component: <Clientms />,
  //   layout: "/admin",
  //   IsVisible: true,

  // },

  // {
  //   path: "/users",
  //   name: "Users",
  //   icon: "fa-solid fa-users text-info",
  //   component: <Users />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },
  // {
  //   path: "/drivers",
  //   name: "Drivers",
  //   icon: "fas fa-user-astronaut text-warning",
  //   component: <Drivers />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },
  // {
  //   path: "/drivers/documents/:user_id",
  //   component: <DriversDocuments />,
  //   layout: "/admin",
  //   IsVisible: false,
  // },

  // {
  //   path: "/drivers/vehicledetail/:user_id",
  //   component: <DriverDetail />,
  //   layout: "/admin",
  //   IsVisible: false,
  // },

  // {
  //   path: "/messages",
  //   name: "Support Message",
  //   icon: "fa-solid fa-comment  text-yellow",
  //   component: <SupportMessages />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  // {
  //   path: "/bookingmanagement",
  //   name: "Booking Management",
  //   // icon: "fa-solid fa-comment  text-yellow",
  //   icon:  "fa-solid fa-list-check text-info",
  //   component: <BookManagement/>,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  // {
  //   path: "/faremanagement",
  //   name: "Fare Management",
  //   // icon: "fa-solid fa-comment  text-yellow",
  //   icon: "fa-solid fa-indian-rupee-sign text-black",
  //   component: <FareManagement />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  // // <i class="fa-solid fa-indian-rupee-sign"></i>

  // {
  //   path: "/rolesandpermission",
  //   name: "Roles & Permission",
  //   // icon: "fa-solid fa-comment  text-yellow",
  //   icon:"fa-solid fa-hand text-yellow",
  //   component: <Rolesandpermission />,
  //   layout: "/admin",
  //   IsVisible: true,
  // },

  // // <i class="fa-solid fa-hand"></i>

  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    IsVisible: false,
  },
];




export default routes;
